<template>
    <div class="label-item" :class="{ selected: selected }" @click="select">
        <div class="col-xs-1">
                <input type="radio" class="hidden m-0" :name="name" :selected="selected"/>
                <i v-show="!selected" class="fa fa-circle-o"></i>
                <i v-show="selected" class="fa fa-check-circle"></i>
            <!--</label>-->
        </div>
        <div class="col-xs-3">
            {{ name }}
        </div>
        <div class="col-xs-4">
            <div class="inline">
                <span class="fg-line">
                    <select class="form-control inline" @change="adjustprice($event.target.value)">
                        <option v-for="(wt, index) in carrier_weight_options" :selected="wt.isSelected" :value="index">{{ wt.weight_option.weight_name }}</option>
                    </select>
                </span>
            </div>
        </div>
        <div class="col-xs-4">
            {{ '$' + selectedPrice }}
        </div>
    </div>
</template>

<style lang="scss">

    @import '../../sass/_global_variables.scss';

    .label-item {
        padding: 15px 0 !important;
        cursor: pointer;
        i {
            margin-bottom: 0;
            font-size: $font-xl;
        }
    }

</style>

<script>
    export default{

        props: [ 'selected', 'name', 'carrier_weight_options' ],

        computed: {
            selectedPrice () {
                let tmpOption = this.carrier_weight_options.find((v) => v.isSelected === true);
                return tmpOption !== undefined ? tmpOption.cost : 0;
            }
        },

        methods: {
            select: function() {
                this.$emit('select');
            },
            adjustprice: function(newPrice) {
                this.$emit('weightchange', newPrice);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// shipping-label-item.vue?211c5f06